import type { EbvChartItem } from './ebvPercentileTypes';

// Extract direction from leftLabel (e.g., "Gest. Len - Longer" -> "Longer")
export function getLeftDirection(leftLabel: string): string {
  const parts = leftLabel.split(' - ');
  return parts[1] || '';
}

/** i4 EBVGraph SplitUp(True, COL.ebv_N_name) — trait name before " - ". */
export function getGraphTraitName(item: EbvChartItem): string {
  const parts = item.leftLabel.split(' - ');
  const fromCol = parts[0]?.trim();
  if (fromCol) return fromCol.replace(/\^/g, ' ');
  return item.label;
}

/** Narrow layout: initials from multi-word label (e.g. "Central Production Index ($)" -> "CPI"). */
export function getCompactTraitLabel(item: EbvChartItem): string {
  // Initialism from the words outside any parenthetical unit/symbol, so it's just the
  // letters — "Central Production Index ($)" -> "CPI", not "CPI(" or "CPI $".
  const words = item.label
    .replace(/\([^)]*\)/g, ' ')
    .split(/\s+/)
    .filter((word) => word.length > 0 && /[A-Za-z0-9]/.test(word[0] ?? ''));
  if (words.length >= 2) {
    return words
      .map((word) => (word[0] != null ? word[0].toUpperCase() : ''))
      .join('');
  }
  const firstWord = words[0];
  return firstWord ? firstWord.slice(0, 10) : item.label;
}

/** BREEDPLAN / i4 v9.2.4+: chart percentile is clamped to 0–100 (stale ref data can exceed bounds). */
export function clampPercentileForChart(percentile: number): number {
  return Math.min(100, Math.max(0, percentile));
}

/** Fixed width (px) for the 100…1 percentile axis so bar geometry is consistent across viewports. */
export const EBV_CHART_AXIS_WIDTH_PX = 500;

/** Fixed narrow columns (px); only the graph axis width is non-resizing. */
export const EBV_TRAIT_NAME_COLUMN_WIDTH_PX = 65;
export const EBV_LEFT_DIRECTION_COLUMN_WIDTH_PX = 62;
export const EBV_RIGHT_DIRECTION_COLUMN_WIDTH_PX = 70;

export const PERCENTILE_SCALE_10 = [
  100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 1,
] as const;

export const PERCENTILE_SCALE_20 = [100, 80, 60, 40, 20, 1] as const;

export function getGuidePosition(percentile: number): string {
  const axisPercentile = percentile === 1 ? 0 : percentile;
  // Axis is rendered 100 (left) to 0 (right).
  return `${100 - axisPercentile}%`;
}
